import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs';
import * as addOnActions from '../../../add-ons/add-on.actions';
import {ServiceOffer} from '../../../data/model';
import * as cartActions from '../../shopping-cart/cart.actions';
import * as eventActions from '../../event-emitter/event.actions';
import * as errorHandlingActions from '../../error-handling/error-handling.actions';
import {AnalyticsService} from './analytics.service';

@Injectable()
export class AnalyticsEffects {
  viewProduct = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(addOnActions.loadAddonSuccess),
        tap(action => {
          if (Array.isArray(action.addon.data)) {
            // [DWB] 2024/04/04 We don't want to log a product impression for list of products.
            // Only when someone opens a product-detail card (fired elsewhere).
            return;
          }
          this.analyticsService.viewProductDetails(
            action.addon.data as ServiceOffer,
          );
        }),
      );
    },
    {dispatch: false},
  );

  addProduct = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(
          cartActions.addItemToCartSuccess,
          cartActions.addItemToCartSuccessThenContinue,
          cartActions.addItemToCartSuccessThenComplete,
          cartActions.addItemToCartSuccessAndRegisterAnother,
          cartActions.addItemToCartSuccessAndContinueToShipping,
        ),
        tap(action => {
          this.analyticsService.cartAction(action.item, 'addToCart');
        }),
      );
    },
    {dispatch: false},
  );

  removeProduct = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(
          cartActions.removeItemFromCartSuccess,
          cartActions.removeItemFromCartSuccessThenContinue,
          cartActions.removeItemFromCartSuccessThenComplete,
          cartActions.removeItemFromCartSuccessThenShipping,
          cartActions.removeItemFromCartThenRegisterAnotherSuccess,
        ),
        tap(action => {
          this.analyticsService.cartAction(action.item, 'removeFromCart');
        }),
      );
    },
    {dispatch: false},
  );

  continueToCheckout = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(eventActions.continueToCheckout),
        tap(() => {
          this.analyticsService.checkoutStep();
        }),
      );
    },
    {dispatch: false},
  );

  registerAnother = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(eventActions.registerAnother),
        tap(() => {
          this.analyticsService.clickEvent('registerAnother');
        }),
      );
    },
    {dispatch: false},
  );

  trackError = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(
          errorHandlingActions.uncaughtError,
          errorHandlingActions.unrecoverableError,
        ),
        tap(({error}) => {
          this.analyticsService.applicationError(error);
        }),
      );
    },
    {dispatch: false},
  );

  constructor(
    private actions$: Actions,
    private analyticsService: AnalyticsService,
  ) {}
}
